import { z } from 'zod'

// This is the schema for mapDeployments that is fetched from the server
// note none are optional.

// question? LiveDate or  LiveDateTime?

export const mapDeploymentsSchema = z.object({
	id: z.string(), // unique id for each entry, this could be incremental number as string '1','2'.
	region: z.string(),
	market: z.string(), // country name
	countryCode: z.string().length(2), // country code two letters 'US', 'GB' etc.

	channelPartner: z.string(), // or empty string '' if not applicable
	provider: z.string(),
	marketPenetration: z.number().min(0).max(100),
	accreditation: z.array(z.string()), // array of strings ['Certified','Accredited']
	liveDate: z.iso.date(), // ISO 8601 https://zod.dev/api#iso-dates -> ✅ 2026-01-21
	link: z.nullable(z.string()), // Allow URL or empty string
	status: z.enum(['live', 'pending']),
})

export type MapDeployment = z.infer<typeof mapDeploymentsSchema>

// export const initialMapDeployment = mapDeploymentsSchema.omit({ id: true })
// export type InitialMapDeployment = z.infer<typeof initialMapDeployment>

export const serverReceivedMapDeployments = z.object({
	deployments: z.array(mapDeploymentsSchema),
	creationTimestamp: z.string(),
	version: z.string().optional(),
})

export type ServerReceivedMapDeployments = z.infer<
	typeof serverReceivedMapDeployments
>

export function validateServerReceivedMapDeployments(
	data: ServerReceivedMapDeployments
) {
	const result = serverReceivedMapDeployments.safeParse(data)
	if (result.error) {
		const pretty = z.prettifyError(result.error)

		return {
			success: false,
			error: `Error parsing ServerReceivedMapDeployments: ${pretty}`,
			isError: true,
		}
		// console.warn(`Error parsing json ${pretty}`);
	} else {
		// console.log(`Json parsed 🎇 success`)
	}
	return { success: true, data: result.data, isError: false }
}
